import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './hooks/useAuth';
import { TrackCacheProvider } from './contexts/TrackCacheContext';
import Layout from './components/layout/Layout';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Personas from './pages/Personas';
import PersonaDetail from './pages/PersonaDetail';
import PersonaCreate from './pages/PersonaCreate';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Settings from './pages/Settings';
import Login from './pages/Login';
import BetaUsers from './pages/BetaUsers';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-jelly-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <TrackCacheProvider>
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />

      {/* Protected admin routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="personas" element={<Personas />} />
        <Route path="personas/new" element={<PersonaCreate />} />
        <Route path="personas/:id" element={<PersonaDetail />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="beta-users" element={<BetaUsers />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
    </TrackCacheProvider>
  );
}
